<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'SELECT_LANGUAGE' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeLanguageModal()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid class="ion-padding">
    <ion-row>
      <ion-col size="6" size-md="4" *ngFor="let lang of availableLanguages | filterAll">
        <div class="language-item"
             [class.selected]="isLanguageSelected(lang)"
             (click)="selectLanguage(lang)">
          <i *ngIf="lang.flag !== 'other'"
             class="flag-icon flag-icon-{{ lang.flag }}"
             [title]="lang.name | translate">
          </i>
          <span class="language-name">{{ lang.name | translate }}</span>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>

  <div class="ion-padding">
    <ion-button expand="block" (click)="closeLanguageModal()" color="tertiary">{{ 'DONE' | translate }} </ion-button>
  </div>
</ion-content>